export default "__VITE_ASSET__9c9dffaa__"